export default {
  SET_CATEGORIES: 'setCategories',
  SET_RESULTS: 'setResults',
  SET_FILTER: 'setFilter',
  SET_PAGINATION: 'setPagination',
};
